import { IExperienceState, INextDailyDates } from "@soposopo/sopo-models";
import { PublicUserInfo } from "../../firebase/profile.service";

export type ProfileComponentId = 'profile-component' | 'community-felts-component';
export interface ProfileComponent {
    componentId: ProfileComponentId;
}

export const PROFILE_COMPONENT_INIT: ProfileComponent = {
    componentId: 'profile-component',
}

export interface ProfileState {
    profileData: ProfileData | null;
    tags: {[index: string]: Tag};
    experience: ExperienceData | OldExperienceData;
    timestamps: INextDailyDates;
    fetchInProgress: boolean;
    error?: any;
    termsAcceptedOnRegistration: boolean;
    activeComponent: ProfileComponent;
}

export const INIT_EXPERIENCE_STATE: ExperienceData = {
    totalEarnedXP: 0,
    convertedXP: 0,
    burnXP: 0,
    inviteXP: {},
    invitedBy: null,
    totalWagesSB: 0,
    loyaltyPointByHand: 0,
    missionXP: 0,
    invitedUsersBonusXP: 0,
    welcomeBonusXP: 0,
    baseWheelSpinReward: 0,
    jackpotWheelSpinReward: 0,
    dailyWheelSpinReward: 0,
};

export const INIT_PROFILE_STATE: ProfileState = {
    profileData: null,
    tags: {},
    experience: {...INIT_EXPERIENCE_STATE},
    timestamps: {
        nextDailyBonus: 0,
        nextStreak: 0,
        nextDailyExp: 0,
        canClaimLoginReward: false,
    },
    fetchInProgress: false,
    termsAcceptedOnRegistration: false,
    error: null,
    activeComponent: {...PROFILE_COMPONENT_INIT},
};

export interface ProfileData extends PublicUserInfo {
    dateCreated: any;
    lastestResponse: any;
    uid: string;
    email: string;
    lastResponseTime: Date;
    lastNameChange: any;
    diamonds: number;
    gpsStatus: boolean;
    golds: number;
    sweepbucks: number;
    jackpotTicket: number;
    termsAccepted: boolean;
    streak: number;
    phoneNumber: string;
    test2faEnabled: boolean;
    emailVerified: boolean;
    zendeskEndUserId: string;
    pendingRequests: string[];
    profileSetupNeeded: boolean | null;
}

export interface Tag extends PlayerTag{
    mutedInChat: boolean;
}

export interface PlayerTag {
    note: string;
    selectedColor: number
}

export interface ExperienceData extends IExperienceState {}

export interface OldExperienceData extends Omit<IExperienceState, 'inviteXP'> {
    inviteXP: {[index: string]: number};
}
